import React, { FC } from 'react';
import { Button, Unstable_Grid2 as Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { useNavigate } from 'react-router-dom';

import { Loaders } from 'components';
import { LeaderboardConfigInput } from 'api';

import { LeaderboardSchema } from 'features/admin/validations';

const FormActions: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { values, dirty, isSubmitting } = useFormikContext<LeaderboardConfigInput>();

  const isValid = LeaderboardSchema(true).isValidSync(values);

  return (
    <Grid container alignItems="center" spacing={3} justifyContent="flex-end">
      <Grid>
        <Button variant="text" onClick={() => navigate(-1)}>
          {t('common:cancel')}
        </Button>
      </Grid>

      <Grid xs={2}>
        <Button
          fullWidth
          type="submit"
          size="large"
          color="primary"
          variant="contained"
          disabled={isSubmitting || !dirty || !isValid}
        >
          {values.id ? t('common:save') : t('common:create')}
          {isSubmitting && <Loaders.Button size={24} />}
        </Button>
      </Grid>
    </Grid>
  );
};

export default FormActions;
